import LynIcon from 'components/@extended/LynIcon';
import { Button, Stack, Typography } from '@mui/material';
import DownloadIcon from 'assets/icons/download';

const ExportButton = ({ handleDataExport }) => {
	return (
		<Button
			disableRipple
			color="secondary"
			aria-haspopup="true"
			aria-label="open profile"
			onClick={handleDataExport}
			sx={{
				height: '36px',
				padding: '5px 12px',
				color: 'text.primary',
				bgcolor: 'common.white',
				border: `1px solid #EdEdEd`,
				borderRadius: '10px',
			}}
		>
			<Stack direction="row" gap={1} sx={{ alignItems: 'center' }}>
				<DownloadIcon color="#000D1A" width="18px" height="18px" />
				<Typography style={{ mt: '12px' }}>Export</Typography>

				{/* <LynIcon folder="icons" fileName={'export'} format="svg" sx={{ marginRight: '4px' }} />{' '}
				<Typography style={{ mt: '12px' }}>Export</Typography> */}
			</Stack>
		</Button>
	);
};

export default ExportButton;
